module.exports = __webpack_public_path__ + "static/img/yaoqing2.7ab8338.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/yaoqing2.png
// module id = /+N0
// module chunks = 24